import Translation from '../models/translation';

const sp: Translation = {
  title: {
    welcome: '¡Bienvenido Topii!',
    onBoarding:
      'Con Topii y RESET puedes solicitar remesas rápidamente a tus contactos de manera fácil y segura, las cuales serán acreditadas inmediatamente en tu Cuenta.',
    confirmRemittance: 'Confirmar Remesa',
    remittanceDetails: 'Detalles de la remesa',
    downloadTopii: 'Descárgate Topii',
    registerTigo: 'Registra tu cuenta RESET',
    privacyPolicy: 'Política de Privacidad',
    userAgreement: 'Términos de Uso',
  },
  text: {
    welcome: [
      'Ahora puedes conversar y solicitar remesas rápidamente a tus contactos de manera fácil y segura.',
      'Sólo tienes que introducir:',
      '1. Nombre y teléfono móvil de la persona',
      '2. Cantidad que deseas solicitar',
      '3. La razón de por qué solicitas la remesa',
    ],
    requestRemittance: 'Solicitar remesa',
    confirmRemittance: '¿Estás seguro que deseas solicitar la remesa?',
    amountRemittance: 'Cantidad a solicitar',
    requesterRemittance: 'Persona a solicitar',
    noteRemittance: 'Nota',
    confirmButtonRemittance: 'Confirmar',
    remittanceRequested: 'Remesa Solicitada',
    requestedAmountRemittance: 'Cantidad solicitada',
    repeatRequestRemittance: 'Repetir Solicitud',
    onBoardingButton: 'EMPEZAR',
    readTerms: 'He leído y acepto los ',
    termsOfUse: 'Términos de Uso',
    termsAnd: ' y la ',
    privacyPolicy: 'Política de Privacidad',
    ofTigo: ' de RESET y Topii.',
    personRequest: 'Persona a solicitar',
    amountRequest: 'Cantidad a solicitar',
    reasonRequest: 'Razón de la solicitud',
    request: 'Solicitar',
    history: 'Historial',
    goBack: 'Volver',
    namePlaceholder: 'Nombre Completo',
    amountPlaceholder: 'DOP',
    reasonPlaceholder: 'Descripción',
    canceled: 'Cancelado',
    received: 'Recibido',
    pending: 'Pendiente',
    id: 'ID: ****',
    repeatRequest: 'Repetir Solicitud',
    enterPhoneNumber: 'Ingrese su Número Telefónico',
    haveRequested: 'Te he Solicitado una remesa por valor de ',
    byReason: ' Razón:',
    seeDetails: 'Ver Detalles',
    writeHere: 'Escribe aquí',
    continue: 'Continuar',
    tigoSMS:
      'RESET enviará un SMS de confirmación al acreditarse la Remesa en tu Cuenta',
    months: [
      'Ene',
      'Feb',
      'Mar',
      'Abr',
      'May',
      'Jun',
      'Jul',
      'Ago',
      'Sep',
      'Oct',
      'Nov',
      'Dic',
    ],
    today: 'Hoy',
    writeSomething: 'Escribe algo...',
    sendRemittanceAttachment: (
      id: string,
      value: string,
      valueConvert: string,
    ) =>
      `Te he enviado una remesa por ${value} (${valueConvert}).\n El ID de la remesa es: ${id}`,
    requestRemittanceAttachment: (value: string, reason: string) =>
      `Te he solicitado una remesa por valor de ${value}. Razón: ${reason}`,
    showDetails: 'Ver Detalles',
    requestChat: 'Iniciar Chat',
    contact: 'Contacto',
    addChat: 'Agregar Chat',
    invite: 'Invitación',
    inviteMessage: (name: string) =>
      `Invita a ${name} a que se una a Topii`,
    inviteMessageOut: 'Te invito a que te unas a Topii topii.com',
    support: 'Soporte',
    faq: 'Preguntas Frecuentes',
    cancel: 'Cancelar',
    accept: 'Aceptar',
    questions: [
      {
        title:
          '¿Cómo puedo solicitar una remesa desde Topii?',
        body: 'Para solicitar una remesa necesitas el número de la persona a quién le harás la solicitud, el monto en dólares y la razón por la cual solicitas la remesa.',
      },
      {
        title: '¿Cómo me pueden enviar remesas desde Topii?',
        body: 'Para poder recibir o solicitar remesas, tu familiar o amigo/a debe crearse una cuenta en Topii y debes compartirle tu código de remesas.',
      },
      {
        title:
          '¿Cuánto es el máximo que puedo solicitar de remesas?',
        body: 'El monto máximo que puedes solicitar es de US$500',
      },
      {
        title:
          '¿Qué tiempo toman las remesas en llegar a mi cuenta?',
        body: 'Las remesas se reflejan en tu cuenta de manera inmediata, las puedes utilizar de una vez para pagar facturas o servicios y puedes retirar dinero en cajeros, sucursales o enviar dinero a otra persona.',
      },
      {
        title: '¿Cuánto cuesta la solicitud de una remesa?',
        body: 'No tiene costo la solicitud de remesas.',
      },
      {
        title:
          '¿En qué moneda se reciben las remesas?',
        body: 'El dinero recibido de las remesas será en pesos dominicanos de acuerdo con la tasa del día.',
      },
      {
        title:
          '¿Desde qué países me pueden enviar dinero?',
        body: 'Las remesas son enviadas desde Estados Unidos únicamente.',
      },
      {
        title: 'Puse el número de teléfono incorrecto a quien le quiero pedir la remesa, ¿qué puedo hacer?',
        body: 'Sí colocas el número incorrecto y la persona no tiene una cuenta en Topii no pasa nada. Puedes hacer una nueva solicitud colocando el número correcto.',
      },
      {
        title:
          'Aún no he recibido mi remesa, ¿a dónde escribo?',
        body: 'Sí eres usuario de Reset debes escribir a ayuda@reset.do con tus datos (selfie con cédula en mano, monto solicitado, fecha y hora) y los datos de la persona a quien le solicitaste la remesa (número de celular y nombre). Te recomendamos también que le digas a la persona que envió la remesa coloque un ticket al soporte de Topii.\n',
      },
      {
        title: 'He recibido un correo electrónico de Topii pidiendo mi información financiera. ¿Debo responder enviando la información requerida? ',
        body: 'No, Topii nunca le enviará correo electrónico no solicitado, requiriendo información financiera. Por favor, contáctenos inmediatamente si sospecha que alguien ha suplantado la identidad y está requiriendo información.',
      },
    ],
    questionsTopii: [
      {
        title:
            '¿Cómo puedo recuperar mi nombre de usuario o clave de seguridad?',
        body: 'Puedes recuperar tu contraseña utilizando la opción "Olvidé mi contraseña" desde la página de inicio de sesión. Para recuperar tu usuario, ingresa la dirección de correo electrónico que utilizaste al registrarte.',
      },
      {
        title: '¿Puedo ver el histórico de mis transacciones realizadas?',
        body: 'Sí, cuando accede a Topii puede revisar su histórico de transacciones en el panel de control',
      },
      {
        title:
            '¿Puedo enviar dinero inmediatamente me registre con Topii?\n',
        body: 'Sí, con la creación de su perfil, queda inmediatamente habilitado para realizar envíos a República Dominicana.',
      },
      {
        title:
            '¿Cómo puedo repetir una transacción de envió de dinero que haya realizado con anterioridad?',
        body: 'Puede repetir una transferencia que haya realizado anteriormente, seleccionándola en el histórico de transacciones y utilizando la opción de reenviar (si esta disponible).',
      },
      {
        title: '¿Debo registrarme para poder realizar una transferencia?',
        body: 'Sí, debe completar debidamente el proceso de registro antes de poder realizar transferencias de dinero.',
      },
      {
        title:
            '¿Cómo agrego un beneficiario? ¿Existe un límite en la cantidad de beneficiarios que puedo agregar?',
        body: 'Seleccione la opción “+” en la parte superior de su pantalla y complete la información requerida. No hay limites para los contactos/beneficiarios que puede agregar.',
      },
      {
        title:
            '¿Qué puedo hacer si detecto que los datos de un beneficiario contienen errores una vez haya completado una transacción?',
        body: 'Una vez se ha enviado una transferencia no es posible realizar cambios a la información de la misma. \n' +
            'De todas maneras, si la información del receptor no es válida, la misma será rechazada y los fondos serán retornados a su cuenta para que pueda iniciar una nueva transferencia con la información de beneficiario correcta\n',
      },
      {
        title: '¿A quiénes puedo enviar dinero?',
        body: 'Puede enviar dinero a cualquier persona en República Dominicana que posea un número de identidad nacional válido y un número de teléfono móvil activo.',
      },
      {
        title:
            '¿Qué información acerca de mi beneficiario tengo que suministrar para enviarles una transferencia?',
        body: 'Necesita agregar el nombre, dirección de correo electrónico, país, dirección, código de remesa y número de teléfono móvil. Esta información es requerida cuando se agrega un beneficiario a su lista.',
      },
      {
        title: '¿Qué es un receptor?',
        body: 'Un receptor es una persona a la cual usted esta enviando dinero. El receptor puede ser si esposa, un pariente, un amigo o cualquier persona a la cual usted le envía dinero. Usted puede convertirse en un receptor en el caso que se este enviado dinero a si mismo a su cuenta en Estados Unidos.',
      },
      {
        title: '¿Existe un límite en el número de receptores a quienes puedo enviar dinero?',
        body: 'No, usted puede agregar tantos receptores como desee.',
      },
      {
        title: '¿Por qué los operadores de transferencia de dinero que trabajan con Topii necesitan hacer una verificación de mis datos?',
        body: 'En su calidad de entidad financiera reguladas, se requiere por ley que sean verificados todos sus clientes. Usualmente solo se requiere verificar el nombre, direcciones fecha de nacimiento y una identificación valida.\n' +
            '\n' +
            '\n' +
            'De todas maneras, en algunos casos se podría requerir de información adicional para dar cumplimiento a las obligaciones regulatorias. Nos pondremos en contacto con usted en el evento que se necesite de información adicional.\n',
      },
      {
        title: 'He recibido un correo electrónico de Topii pidiendo mi información financiera. ¿Debo responder enviando la información requerida?',
        body: 'No, Topii nunca le enviará correo electrónico no solicitado, requiriendo información financiera. Por favor, contáctenos inmediatamente si sospecha que alguien ha suplantado la identidad de Topii y esta requiriendo información.',
      },
      {
        title: '¿Cómo puedo dar seguimiento al estado de mi transacción?',
        body: 'Topii le permite seguir en tiempo real el estado de su transacción desde el momento que la envía.',
      },
      {
        title: '¿Puedo cancelar mi transacción de envío de dinero en línea? ¿Existe un costo por cancelación?',
        body: 'Las transacciones de Topii se realizan en tiempo real, una vez se confirma el envía de la remesa, esta no puede ser cancelada o modificada.',
      },
      {
        title: '¿Cómo debo proceder en el evento de que no me sea retornado a la cuenta el monto de una transferencia que no fue acreditada al receptor?',
        body: 'En la sección de ayuda dentro del chat podrás colocar un ticket con los datos solicitados.',
      },
      {
        title: '¿Puedo cancelar o reversar una transferencia completada?',
        body: 'No, no se puede modificar o cancelar una transferencia completada.',
      },
      {
        title: '¿Cómo puedo pagar mi transferencia?',
        body: 'Puede pagar utilizando su cuenta de banco y/o mediante una tarjeta de débito emitida en USA.',
      },
      {
        title: '¿Cómo puedo verificar la tasa de cambio?',
        body: 'Una ves el monto de la transacción y método de pago ha sido completado, la información de tasas y comisiones se despliega en su pantalla antes de confirmar el envío.',
      },
      {
        title: '¿Puedo obtener un recibo por una transferencia realizada?',
        body: 'Si, recibirá un recibo y un número único para cada transacción individual realizada. Puede acceder al recibo al finalizar la operación de envío, el cual puede imprimir o compartir a su conveniencia.',
      },
      {
        title: '¿Están seguros mis fondos con Topii?',
        body: 'Si, los proveedores de servicio de Topii emplean numerosas medidas para asegurar que su dinero así como su información personal este protegida en todo momento utilizando centros de procesamiento altamente seguros para almacenar datos, servicios de atención a cliente para atender inmediatamente dudas e inquietudes, etc. De igual manera, el servicio Topii esta en total cumplimiento con las regulaciones estatales y federales. Por favor revisar los términos y condiciones del servicio.',
      },
      {
        title: '¿Qué sucede si la transacción falla?',
        body: 'Si la transacción falla y el receptor no esta disponible para recibir la transferencia, los fondos serán acreditados a fuente original un plazo no mayor de 2 días laborables.',
      },
      {
        title: '¿A quién debo dirigirme si hay necesidad de arreglos, cambios, cancelaciones, etc.?',
        body: 'En la sección de ayuda dentro del chat podrás colocar un ticket con los datos solicitados.',
      },
      {
        title: '¿Debe estar registrado el receptor en Topii para recibir una transferencia?',
        body: 'No, el receptor no tiene que estar registrado con CHAPii Chat para recibir una transferencia; es altamente recomendable que se registre a fin de disfrutar el servicio y beneficios de punta a punta que esta ofrece.',
      },
      {
        title: '¿Cómo sé que mi transferencia fue exitosa?',
        body: 'Puede ver el estado de la transacción en tiempo real e su pantalla, desde el mismo momento en que ordena la ejecución de la transacción.',
      },
      {
        title: '¿Dónde encuentro información sobre las tasas de cambio de monedas?',
        body: 'Después de ingresar el monto que le gustaría enviar, puede ver el equivalente en moneda local del receptos justo al lado del valor en dólares. Esta información es valida solamente para la operación en curso.',
      },
      {
        title: '¿Como el receptor recibe el dinero enviado por vía de Topii?',
        body: 'El dinero será acreditado en la cuenta de monedero electrónico del beneficiario.',
      },
      {
        title: '¿Puedo enviar dinero fuera del horario de servicios bancarios? ¿Existe alguna dilación si envío dinero fuera de horario de servicio bancario?',
        body: 'Si, puede enviar dinero en tiempo real las 24 horas los 7 días de la semana. Para servicio al cliente por favor refiérase al horario publicado.',
      },
      {
        title: '¿Puedo enviar y recibir dinero de cualquier país a través de Topii?',
        body: 'Actualmente puede enviar dinero desde todos los Estados Unidos de Norteamérica hacia República Dominicana. Se irán incorporando mas países paulatinamente.',
      },
      {
        title: '¿Puedo enviar dinero a cualquier banco?',
        body: 'Actualmente solo puede enviarse dinero para ser acreditado en los monederos electrónicos de RESET.',
      },
      {
        title: '¿Qué tiempo toma la ejecución de una transferencia?',
        body: 'La mayoría de las remesas se completan dentro de un plazo de 2 minutos. De todas maneras, algunas transacciones pueden presentar retrasos en el evento que la información de quien envía y de quien recibe requiera de confirmación adicional de acuerdo con los entes reguladores actuantes tanto en el país de origen como el de destino.',
      },
      {
        title: '¿Por qué retornaron los fondos de la transferencia a mi cuenta? ¿Qué debo hacer?',
        body: 'Sus fondos pueden haber sido retornados por varias razones. Por ejemplo, la información de la cuenta del receptor no estaba correcta o la cuento no esta disponible, o, la transacción fue objetada por la verificación regulatoria. Se enviará un correo electrónico al ordenante indicando las razones por la cual no se pudo ejecutar la transferencia.',
      },
      {
        title: '¿En qué moneda se recibirá el receptor el dinero enviado?',
        body: 'El receptor recibirá el dinero enviado en la moneda nacional del país al que fue enviada la transferencia.',
      },
      {
        title: '¿Puedo cambiar la información del receptor?',
        body: 'Sí, puede modificar la información del receptor.',
      },

    ],
    warning: 'Advertencia',
    deleteMessage: '¿Está seguro que desea eliminar el chat?',
    archive: 'Archivar',
    delete: 'Eliminar',
    close: 'Cerrar',
    clientError:
      'Hubo un problema con su conexión. Por favor, inténtelo de nuevo más tarde',
    serverError:
      'Hubo un problema con el servidor. Por favor, inténtelo de nuevo más tarde',
    registerTigoMsg:
      'Introduzca sus datos en los siguientes campos exáctamente como están registrados en su cuenta RESET. No añadir acentos, eñes o diéresis',
    firstName: 'Primer Nombre',
    firstNamePlaceholder: 'Ingresa tu primer nombre aquí',
    middleName: 'Segundo Nombre',
    middleNamePlaceholder: 'Ingresa tu segundo nombre aquí',
    firstLastName: 'Primer Apellido',
    firstLastNamePlaceholder: 'Ingresa tu primer apellido aquí',
    secondLastName: 'Segundo Apellido',
    secondLastNamePlaceholder: 'Ingresa tu segundo apellido aquí',
    birthDate: 'Fecha de Nacimiento',
    birthDatePlaceholder: 'AAAA-MM-DD',
    birthDateMax: 'Tienes que ser mayor de 18 años para utilizar Topii',
    city: 'Ciudad',
    cityPlaceholder: 'Ingresa tu ciudad aquí',
    province: 'Provincia',
    provincPlaceholder: 'Ingresa tu provincia aquí',
    phoneNumber: 'Número Telefónico',
    validField: (value: string) => `${value} tiene que ser un valor válido`,
    requiredField: (value: string) => `${value} es un campo requerido`,
    characterValidField: (value: string) =>
      `${value} no puede contener acentos, eñes o diéresis`,
    confirmRegistry:
      'Por favor, revisa que tus datos han sido ingresados correctamente',
    edit: 'Editar',
    error: 'Error',
    invalidPhoneNumber: 'El número de teléfono es inválido',
    minAmount: (value: number) => `La cantidad mínima es ${value}`,
    maxAmount: (value: number) => `La cantidad máxima es ${value}`,
    receivedRemittance: 'Remesa Recibida',
    sender: 'Remitente',
    receivedAmountRemittance: 'Cantidad Recibida',
    requested: 'Solicitado',
    noRemittances: 'El historial esta vacío',
    codeRemittance: 'Código de remesas',
    topiiUsers: 'Usuarios Topii',
    resetUsers: 'Usuarios Reset',
    ohOh: '¡Oh Oh!',
    serviceOnManteinance: 'El servicio se encuentra en mantenimiento'
  },
};

export default sp;
